// OrderWrapper.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "./firebaseConfig";
import { getDoc, doc } from "firebase/firestore";
import OrderPage from "./OrderPage";

const OrderWrapper = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (authUser) => {
      if (!authUser) {
        navigate("/");
        return;
      }

      const userRef = doc(db, "users", authUser.uid);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        const fullUser = {
          uid: authUser.uid,
          email: authUser.email,
          ...userSnap.data(),
        };

        if (!fullUser.approved) {
          alert("Your account is not approved.");
          navigate("/");
          return;
        }

        setUserData(fullUser);
      } else {
        alert("User not found in database.");
        navigate("/");
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, [navigate]);

  if (loading) return <div>Loading...</div>;

  return (
    <OrderPage
      user={userData}
      isAdmin={userData.role === "admin"}
      userStore={userData.store}
      selectedStore={userData.store}
      setSelectedStore={() => { }}
      isOnline={true}
    />
  );
};

export default OrderWrapper;
